import React from 'react';
import {useDispatch} from 'react-redux';
import {Card, Loader, Table, Dropdown} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {pageSizes} from '../../../common/constants/lists';
import TablePaginator from '../../../common/components/tablePaginator';

const {changeAccessoriesOrdersPage, resizeAccessoriesOrdersPage} = Actions;

const TableBody = ({ordersFiltered, type}) => {
  function renderDate(date) {
    return date ? date.substring(0, 10) : null;
  }

  function getInvoiceType(anticipatedInvoice) {
    return anticipatedInvoice && anticipatedInvoice === 'S' ? 'ANTICIPADA' : 'NORMAL';
  }

  function renderOrder(index, order) {
    return (
      <Table.Row key={index}>
        <Table.Cell>{order.dealer}</Table.Cell>
        <Table.Cell>{order.location}</Table.Cell>
        <Table.Cell>{order.description}</Table.Cell>
        <Table.Cell>{order.chassis}</Table.Cell>
        <Table.Cell>{order.color}</Table.Cell>
        <Table.Cell>{renderDate(order.date)}</Table.Cell>
        <Table.Cell>{renderDate(order.modificationDate)}</Table.Cell>
        <Table.Cell>{order.modificationUser}</Table.Cell>
        <Table.Cell textAlign='center'>{getInvoiceType(order.anticipatedInvoice)}</Table.Cell>
        <Table.Cell className='order-code' textAlign='center'>
          {order.order}
        </Table.Cell>
        <Table.Cell>{order.cancelReason}</Table.Cell>
      </Table.Row>
    );
  }

  if (!ordersFiltered.length) {
    return (
      <Table.Body>
        <Table.Row textAlign='center'>
          <Table.Cell colSpan={type === 'pds' ? 10 : 11}>
            No hay órdenes canceladas
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    );
  }

  return (
    <Table.Body>
      {ordersFiltered.map((item, index) => renderOrder(index, item))}
    </Table.Body>
  );
};

const CanceledOrders = ({type, devicesOrders}) => {
  const dispatch = useDispatch();
  const {searchDate, loading, pageSize, page, list, filteredList} =
  devicesOrders;

  function handlePageChange(value) {
    dispatch(changeAccessoriesOrdersPage(value));
  }

  function handlePageResize(event, data) {
    dispatch(resizeAccessoriesOrdersPage(data.value));
  }

  if (!searchDate) {
    return null;
  }

  if (loading) {
    return (
      <Card raised fluid className='orders-detail'>
        <Loader active inline='centered'>
          Procesando...
        </Loader>
      </Card>
    );
  }

  return (
    <Card raised fluid className='orders-detail'>
      <Table striped>
        <Table.Header className='orders-table-header'>
          <Table.Row>
            <Table.HeaderCell>Concesionario</Table.HeaderCell>
            <Table.HeaderCell>Ubicación</Table.HeaderCell>
            <Table.HeaderCell>Descripción</Table.HeaderCell>
            <Table.HeaderCell>Chasis</Table.HeaderCell>
            <Table.HeaderCell>Color</Table.HeaderCell>
            <Table.HeaderCell>Fecha Programada</Table.HeaderCell>
            <Table.HeaderCell>Fecha Anulación</Table.HeaderCell>
            <Table.HeaderCell>Usuario Anulación</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Tipo Facturación</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Nro. Orden</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              Motivo de Anulación
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <TableBody type={type} ordersFiltered={filteredList} />
        {list.length > pageSize && (
          <Table.Footer>
            <Table.Row textAlign='center'>
              <Table.HeaderCell colSpan='100%'>
                <div className='table-pagination'>
                  <span className='page-sizer'>
                    <strong>Items por página</strong>
                    <Dropdown
                      selection
                      upward
                      compact
                      value={pageSize}
                      options={pageSizes}
                      onChange={handlePageResize}
                    />
                  </span>
                  <TablePaginator
                    itemsCount={list.length}
                    itemsPerPage={pageSize}
                    selectedPage={page}
                    onOptionClick={handlePageChange}
                  />
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        )}
      </Table>
    </Card>
  );
};

export default CanceledOrders;
